import { useChat } from "~/hooks/chat";
import { Container } from "./styles";

const FormSend: React.FC = () => {
  const { isExternal, company, company_domain } = useChat();
  console.log(`A URL é ${company_domain}`);

  const companyConfigr = "5278e21e-e651-4883-8370-c61162f58d61";

  return (
    <Container>
      <div>
        <span>Obrigado por entrar em contato!</span>
        <br />
        <span>Sua mensagem foi encaminhada com sucesso à nossa equipe.</span>
      </div>
      <img src="https://chat.cloudez.io/noneChats.svg" alt="Chat Contact" />
      <span className="schedules">Entraremos em contato em breve.</span>
      {isExternal ? (
        <span>
          Caso preferir, pode entrar em contato com a gente enviando um e-mail
          para{" "}
          <b>
            {company === companyConfigr
              ? "comercial@configr.com"
              : "selecao@cloudez.io "}
          </b>
        </span>
      ) : (
        <span>
          Caso preferir, pode entrar em contato com a gente utilizando abertura
          de um{" "}
          <a
            className="openTicket"
            href={`${window.location.origin}/tickets/create`}
          >
            ticket
          </a>
          .
        </span>
      )}
    </Container>
  );
};

export default FormSend;
